import apiUrl from '../../api/url'

const url = {
  state: apiUrl,
}

export default url
